<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">

              <div class="section-card">
                <div class="section-title">Devis alternatifs pour le RCDA</div>
                <p class="section-description">
                  Sélectionnez jusqu'à 2 devis alternatifs à comparer avec le contrat recommandé dans le RCDA.
                </p>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column label="Devis alternatif 1" [derrors]="derrors" [isDefault]="false">
                      <pr-select-search
                        formControlName="devisAlternatif1Id"
                        label="Sélectionner un devis"
                        [options]="availableDevisForAlt1"
                        optionDisplayKey="label"
                        optionValueKey="value"
                      ></pr-select-search>
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-column label="Devis alternatif 2" [derrors]="derrors" [isDefault]="false">
                      <pr-select-search
                        formControlName="devisAlternatif2Id"
                        label="Sélectionner un devis"
                        [options]="availableDevisForAlt2"
                        optionDisplayKey="label"
                        optionValueKey="value"
                      ></pr-select-search>
                    </pr-input-column>
                  </div>
                </div>
              </div>

            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>

<pr-modal-confirm
  display="warning"
  title="Aucun devis alternatif sélectionné"
  labelConfirm="Continuer sans comparatif"
  labelCancel="Revenir"
  (onConfirm)="confirmSkipDevis()"
>
  <p>Vous n'avez sélectionné aucun devis alternatif.</p>
  <p>Le RCDA ne contiendra pas de tableau comparatif des contrats.</p>
</pr-modal-confirm>
